import { render, staticRenderFns } from "./MemberEditTabMarital.vue?vue&type=template&id=74ab1989"
import script from "./MemberEditTabMarital.vue?vue&type=script&lang=js"
export * from "./MemberEditTabMarital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports